import React, { useContext, useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import useQueryParams from "utils/hooks/useQueryParams";
import { MobileContext, ModalContext } from "components/common";
import { useMutation } from "@apollo/react-hooks";
import decode from "jwt-decode";
import {
  PROCESS_PAYMENT,
  UPDATE_PAYMENT_METHODS,
  REFETCH_PAYMENT_METHODS,
  ADD_PAYMENT_METHOD,
  REMOVE_PAYMENT_METHOD,
  UPDATED_FINICITY_PAYMENT_METHODS
} from "utils/mutations";
import { track } from "utils/analytics";
import UpdateAccount from "./common/UpdateAccount";
import ManagePaymentMethodsMobile from "./ManagePaymentMethodsMobile";
import ManagePaymentMethodsDesktop from "./ManagePaymentMethodsDesktop";
import UpdateAccountFinicity from "./common/UpdateAccountFinicity";
import { ERROR_STATUS } from 'utils/constants';

function ManagePaymentMethods({
  user,
  setSuccess,
  next,
  setError,
  resetSuccess = () => {},
  SettingsButton,
  SettingsInputContainer,
  roles,
}) {
  // plaid update item stuff
  const queryParams = useQueryParams();
  const section = queryParams.get("section");
  const itemId = queryParams.get("id");
  const linkAggegator = queryParams.get("type");
  const key = queryParams.get("key");
  const initialItemId = section === "manage-payment-methods" && itemId;
  const token = window.localStorage.getItem("jwt") || "";
  let showSmartPay;
  try {
    const { account_features = {} } = decode(token);
    const { smart_pay } = account_features || {};
    showSmartPay = !!smart_pay;
  } catch (error) {
    console.log("Error decoding jwt in ManagePaymentMethods:", error);
  }

  const { isMobile } = useContext(MobileContext);
  const { openModal } = useContext(ModalContext);
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(
    user.default_payment_method_id || ""
  );
  const [secondaryPaymentMethod, setSecondaryPaymentMethod] = useState(
    user.secondary_payment_method_id || null
  );
  const [smartPayEnabled, setSmartPayEnabled] = useState(
    user.smart_pay || false
  );
  const [autopayFrequency, setAutopayFrequency] = useState(
    user.autopay_frequency || ""
  );
  const [hasChanges, setHasChanges] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [plaidUpdateItem, setPlaidUpdateItem] = useState(
    linkAggegator !== "finicity" ? initialItemId : null
  );
  const [finicityUpdateItem, setFinicityUpdateItem] = useState(
    linkAggegator === "finicity" ? initialItemId : null
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [updatePaymentMethods] = useMutation(UPDATE_PAYMENT_METHODS);
  const [addPaymentMethod] = useMutation(ADD_PAYMENT_METHOD);
  const [removePaymentMethod] = useMutation(REMOVE_PAYMENT_METHOD);
  const [updateFinicityPaymentMethods] = useMutation(
    UPDATED_FINICITY_PAYMENT_METHODS
  );
  const [processPayment] = useMutation(PROCESS_PAYMENT);

  useEffect(() => {
    if (section && itemId && key) {
      const shouldUpdate = section === "manage-payment-methods" && itemId;
      if (shouldUpdate) {
        if (linkAggegator === "finicity") setFinicityUpdateItem(itemId);
        else setPlaidUpdateItem(itemId);
      }
    }
  }, [key, itemId, section]);

  // update plaid account stuffs

  const Component = isMobile
    ? ManagePaymentMethodsMobile
    : ManagePaymentMethodsDesktop;

  const removeUserPaymentMethod = paymentMethodId => {
    console.log("removing payment method", paymentMethodId);
    setInProgress(true);
    removePaymentMethod({
      variables: {
        id: paymentMethodId,
        userId: user.email
      },
      refetchQueries: ["Settings"],
      awaitRefetchQueries: true
    })
      .then(res => {
        setInProgress(false);
        console.log("Remove payment method mutation returned", res);
        if (
          res.data &&
          res.data.removePaymentMethod &&
          res.data.removePaymentMethod.error
        ) {
          if (!isMobile) {
            setError(true);
          }
          setErrorMessage(res.data.removePaymentMethod.message);
        } else if (!isMobile) {
          setSuccess();
        }
      })
      .catch(e => {
        setInProgress(false);
        console.log("Error removing user payment method:", e.message);
        setErrorMessage(e.message);
      });

    // axios
    //   .post("/user/paymentMethods/remove", {
    //     userId: user.email,
    //     paymentMethodId
    //   })
    //   .then(response => {
    //     if (response.data.success) {
    //       console.log("Successfully removed account:", response.data);
    //       return;
    //     }
    //     console.log("Error removing account:", response.data);
    //     setInProgress(false);
    //   }).catch(error => {
    //     console.log("Error removing account:", error);
    //     setInProgress(false);
    //   });
  };

  const addUserPaymentMethod = data => {
    const { accounts, institution, link_session_id, public_token } = data;

    setInProgress(true);

    addPaymentMethod({
      variables: {
        accounts,
        institution,
        link_session_id,
        public_token
      },
      refetchQueries: ["Settings"],
      awaitRefetchQueries: true
    })
      .then(res => {
        setInProgress(false);
        console.log("Add payment method mutation returned", res);
        if (
          res.data &&
          res.data.removePaymentMethod &&
          res.data.removePaymentMethod.error
        ) {
          if (!isMobile) {
            setError(true);
          }
          setErrorMessage(res.data.addPaymentMethod.message);
        } else if (!isMobile) {
          setErrorMessage(null);
          setSuccess();
        }
      })
      .catch(({ graphQLErrors }) => {
        setInProgress(false);
        console.log("Error adding user payment method:", graphQLErrors);
        if (!isMobile) {
          setError(true);
        }
        setErrorMessage(
          ((graphQLErrors || [])[0] || {}).message || "Something went wrong"
        );
      });

    // axios.post("/user/paymentMethods/add", data).then(response => {
    //   if (response.data.success) {
    //     console.log("Successfully added accounts:", response.data.accounts);
    //     return;
    //   }
    //   console.log("Error adding accounts:", response.data);
    // });
  };

  const relinkPaymentMethod = (id, aggregator) => {
    console.log("id", id);
    if (aggregator === "finicity") setFinicityUpdateItem(id);
    else setPlaidUpdateItem(id);
  };

  const handlePaymentMethodChanged = data => {
    // console.log("User changed payment method to:", data);
    setErrorMessage("");
    setDefaultPaymentMethod(data.id);
    setHasChanges(true);
    if (!isMobile) {
      setError(false);
      resetSuccess();
    }
  };

  const updateUserFinicityPaymentMethods = () => {
    setInProgress(true);

    updateFinicityPaymentMethods({
      variables: {},
      refetchQueries: ["Settings"],
      awaitRefetchQueries: true
    })
      .then(res => {
        setInProgress(false);
        console.log("updateFinicityPaymentMethods returned", res);
        if (
          res?.data?.updateFinicityPaymentMethods?.status === ERROR_STATUS
        ) {
          if (!isMobile) {
            setError(true);
          }
          setErrorMessage(res.data.updateFinicityPaymentMethods.message);
        } else if (!isMobile) {
          setErrorMessage(null);
          setSuccess();
        }
      })
      .catch(({ graphQLErrors }) => {
        setInProgress(false);
        console.log("Error updating finicity payment methods:", graphQLErrors);
        if (!isMobile) {
          setError(true);
        }
        setErrorMessage(
          ((graphQLErrors || [])[0] || {}).message || "Something went wrong"
        );
      });
  };

  const handleSmartPaySettingsChanged = data => {
    console.log(`SmartPay ${data.enabled ? "enabled" : "disabled"}`);
    setErrorMessage("");
    setSmartPayEnabled(data.enabled);
    setHasChanges(true);
    if (!isMobile) {
      resetSuccess();
    }
  };

  const handleSmartPayMethodChanged = data => {
    console.log("SmartPay backup payment method selected:", data);
    setErrorMessage("");
    if (data) setSecondaryPaymentMethod(data.id);
    else setSecondaryPaymentMethod(null);
    setHasChanges(true);
    if (!isMobile) {
      setError(false);
      resetSuccess();
    }
  };

  const handlePaymentSettingsChanged = data => {
    // console.log("User changed payment setting to:", data);
    setErrorMessage("");
    setAutopayFrequency(data.value.toLowerCase());
    setHasChanges(true);
    if (!isMobile) {
      resetSuccess();
    }
  };

  const completeUpdate = async () => {
    track("DASHBOARD_SETTINGS_PAYMENT_METHOD_CHANGE_SUBMITTED");

    if (smartPayEnabled && defaultPaymentMethod === secondaryPaymentMethod) {
      setErrorMessage(
        "Default payment method and SmartPay payment method cannot be the same"
      );
      return;
    }

    setInProgress(true);
    setErrorMessage("");
    // eslint-disable-next-line
    const shouldRefetch = autopayFrequency != user.autopay_frequency;

    const variables = {
      user_id: user.email,
      default_payment_method_id: defaultPaymentMethod,
      ...(smartPayEnabled && {
        secondary_payment_method_id: secondaryPaymentMethod
      }),
      autopay_frequency: autopayFrequency,
      smart_pay: smartPayEnabled
    };

    return updatePaymentMethods({
      variables,
      refetchQueries: () => [{ query: REFETCH_PAYMENT_METHODS }],
      awaitRefetchQueries: true
    })
      .then(res => {
        console.log(res);
        track("DASHBOARD_SETTINGS_PAYMENT_METHOD_CHANGE_SUCCESS");
        setInProgress(false);
        setErrorMessage("");
        setHasChanges(false);
        return { success: true };
      })
      .catch(e => {
        console.log(e.message);
        track("DASHBOARD_SETTINGS_PAYMENT_METHOD_CHANGE_FAILURE", {
          message: "Error updating payment methods"
        });
        setInProgress(false);
        setErrorMessage(
          "Couldn't update your payment method. Please try again later."
        );
        setHasChanges(false);
        return { success: false };
      });
  };

  const saveChanges = async data => {
    if (
      autopayFrequency !== user.autopay_frequency &&
      user.autopay_frequency === "monthly" &&
      user.credit.credit_used > 0.02
    ) {
      openModal(null, "SettingsPaymentModal", {
        processPayment,
        user,
        defaultPaymentMethod,
        completeUpdate,
        autopayType: autopayFrequency
      });
      return;
    }
    return completeUpdate(data);
  };

  const EnhancedSettingsButton = () => (
    <SettingsButton
      buttonContainerClassName={isMobile ? "" : "inline-block"}
      onClick={e => {
        return saveChanges(e)
          .then(r => {
            return r;
          })
          .catch(e => {
            return e;
          });
      }}
      disabled={inProgress || !hasChanges}
    >
      <p>Save Changes</p>
    </SettingsButton>
  );

  return (
    <>
      <Component
        user={user}
        SettingsButton={EnhancedSettingsButton}
        SettingsInputContainer={SettingsInputContainer}
        addPaymentMethod={addUserPaymentMethod}
        removePaymentMethod={removeUserPaymentMethod}
        relinkPaymentMethod={relinkPaymentMethod}
        handlePaymentMethodChanged={handlePaymentMethodChanged}
        updateFinicityPaymentMethods={updateUserFinicityPaymentMethods}
        handlePaymentSettingsChanged={handlePaymentSettingsChanged}
        handleSmartPayMethodChanged={handleSmartPayMethodChanged}
        handleSmartPaySettingsChanged={handleSmartPaySettingsChanged}
        disabledDefaultPaymentMethodIds={
          smartPayEnabled ? [secondaryPaymentMethod] : []
        }
        disabledSmartPayPaymentMethodIds={[defaultPaymentMethod]}
        complete={next || setSuccess}
        saveChanges={saveChanges}
        inProgress={inProgress}
        errorMessage={errorMessage}
        hasChanges={hasChanges}
        setErrorMessage={setErrorMessage}
        resetSuccess={resetSuccess}
        setError={setError}
        isMobile={isMobile}
        roles={roles}
        showSmartPay={showSmartPay}
      />
      {!!plaidUpdateItem && (
        <UpdateAccount
          complete={next || setSuccess}
          itemId={plaidUpdateItem}
          open={!!plaidUpdateItem}
          setErrorMessage={setErrorMessage}
          reset={() => setPlaidUpdateItem(null)}
        />
      )}
      {!!finicityUpdateItem && (
        <UpdateAccountFinicity
          complete={next || setSuccess}
          itemId={finicityUpdateItem}
          open={!!finicityUpdateItem}
          setErrorMessage={setErrorMessage}
          reset={() => setFinicityUpdateItem(null)}
        />
      )}
    </>
  );
}

const mapStateToProps = state => ({
  roles: state.user.roles
});

export default compose(connect(mapStateToProps))(ManagePaymentMethods);
